import React, { useState } from "react";
import styled from "styled-components";
import CloseButton from "@common/LifeAtButton/Buttons/CloseButton";
import CalendarSignInButtonRow from "./CalendarSignInButtonRow";

const CALENDAR_SIGN_IN_LABEL = "Connect your calendar:";

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    padding: 10px 10px 0 10px;

    width: 100%;

    border-bottom: 1px solid ${(props) => props.theme.borderPrimary};
`;

const SignInContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin-top: 10px;
`;

const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
`;

const StyledCloseButton = styled(CloseButton)`
    .lifeat-button {
        padding: unset;
        min-height: unset;
    }
`;

interface CalendarSignInHeaderProps {
    className?: string;
}
function CalendarSignInHeader(props: CalendarSignInHeaderProps) {
    const [signInOpen, setSignInOpen] = useState(true);

    const handleClose = () => {
        setSignInOpen(false);
    };

    return (
        signInOpen && (
            <HeaderWrapper className={`calendar-header ${props.className}`}>
                <SignInContainer>
                    <HeaderRow>
                        <span>{CALENDAR_SIGN_IN_LABEL}</span>
                        <StyledCloseButton className={`calendar-signin-close-button`} handleClose={handleClose} />
                    </HeaderRow>
                    <ButtonContainer>
                        <CalendarSignInButtonRow />
                    </ButtonContainer>
                </SignInContainer>
            </HeaderWrapper>
        )
    );
}

export default CalendarSignInHeader;
